import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Layout from '../../../components/Layout/layout.component';
import ToastHelper from '../../../utils/toastHelper';
import { LoadingStyle } from './layout.style';

const mapStateToProps = state => ({
	loading: state.loading,
});

class LayoutContainer extends Component {
	componentDidMount() {
		ToastHelper.create();
		/* Monitora o histórico do browser */
		this.props.history.listen(() => {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		});
	}

	render() {
		const { children, loading } = this.props;
		return (
			<Fragment>
				<Fragment>
					<Layout>{children}</Layout>
					{loading.loading && (
						<LoadingStyle className='loading'>
							<div className='text-center'>
								<div className='spinner-border' role='status'>
									<span className='sr-only'>Loading...</span>
								</div>
							</div>
						</LoadingStyle>
					)}
				</Fragment>
			</Fragment>
		);
	}
}

export default withRouter(connect(
	mapStateToProps,
	null,
)(LayoutContainer));
